import React from 'react'
import IconBase from './IconBase'

const Event = props =>
  <IconBase viewBox="-969.056 -1103.154 69.056 70.154" {...props}>
    <g transform="translate(-970.03 -1103.2)">
      <g transform="translate(.977)">
        <path transform="translate(-17.452 -22.284)" d="M43.93,67.452l-1.077,6.39A2.331,2.331,0,0,0,46.236,76.3l5.747-3.007L57.73,76.3a2.332,2.332,0,0,0,3.383-2.456l-1.088-6.39,4.627-4.539a2.332,2.332,0,0,0-1.291-3.973l-6.413-.951L54.067,52.18a2.332,2.332,0,0,0-4.178,0L47,57.986l-6.413.951A2.332,2.332,0,0,0,39.3,62.91Z" />
        <path transform="translate(-.977)" d="M63.066,7.458H55.721V3.383A3.383,3.383,0,0,0,52.329,0h-.538a3.383,3.383,0,0,0-3.383,3.383V7.458h-25.9V3.383A3.383,3.383,0,0,0,19.123,0h-.538A3.383,3.383,0,0,0,15.2,3.383V7.458H7.944A6.975,6.975,0,0,0,.977,14.425V63.187a6.976,6.976,0,0,0,6.967,6.967H63.066a6.976,6.976,0,0,0,6.967-6.967V14.425a6.975,6.975,0,0,0-6.967-6.967Zm-.91,54.82H8.852V24.32h53.3Z" />
      </g>
    </g>
  </IconBase>

export default Event
